var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.878 15.0089C16.878 16.8449 15.3183 18.3333 13.3944 18.3333H6.4271C4.50315 18.3333 2.94347 16.8449 2.94347 15.0089V10.9441C2.94347 10.354 2.69779 9.78794 2.26047 9.37061C1.24723 8.4037 1.37895 6.80165 2.53781 5.99737L7.86176 2.30244C9.08329 1.45467 10.7382 1.45467 11.9597 2.30244L17.2836 5.99737C18.4425 6.80165 18.5742 8.4037 17.561 9.37061C17.1237 9.78794 16.878 10.354 16.878 10.9441V15.0089ZM9.91073 14.9999C10.8312 14.9999 11.5774 14.2538 11.5774 13.3333C11.5774 12.4128 10.8312 11.6666 9.91073 11.6666C8.99025 11.6666 8.24406 12.4128 8.24406 13.3333C8.24406 14.2538 8.99025 14.9999 9.91073 14.9999Z",
    fill: "#26B0EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.08d08a16bc046ded003a271e69081b50.svg";
export { ForwardRef as ReactComponent };